
// EditarApagar.js

import React, { useState, useEffect } from 'react';
import TipoField from './TipoField';
import CodigoField from './CodigoField';
import DatepickerField from './DatepickerField';
import CurrencyField from './CurrencyField';
import CondPagamentoSelect from './CondPagamentoSelect';
import FormaPagamentoSelect from './FormaPagamentoSelect';
import Box from '@mui/material/Box';
import ModalDetahesCliente from './ModalDetalhesCliente'; // Certifique-se de que o caminho está correto
import ModalEditarItensVenda from './ModalEditarItensVenda'; // Certifique-se de que o caminho está correto
import ModalPesquisarCliente from './ModalPesquisarCliente'; // Adicione esta linha
import ModalContasAreceber from './ModalContasAreceber';
import ModalBoletoControl from './ModalBoletoControl';
//import Axios from 'axios';
import api from '../config/axiosConfig';
import '../App.css';
import './ModalDetalhesCliente.css';
import './ModalContasAreceber.css';
import './ModalBoletoControl.css'; 

function EditarApagar({ venda, handleEditClick, handleCancelaEdit }) {

  const [isSaving, setIsSaving] = useState(false);
  const [detalhesVenda, setDetalhesVenda] = useState(venda);
  const [detalhesCliente, setDetalhesCliente] = useState(false);

  // eslint-disable-next-line no-unused-vars
  const [itensVenda, setItensVenda] = useState([]);
  const [editarItensVenda, setEditarItensVenda] = useState(false);
  const [codVendaParaEditar, setCodVendaParaEditar] = useState(null);
  const [pesquisarCliente, setPesquisarCliente] = useState(false); // Estado para controlar a abertura do modal de pesquisa de clientes
  const [isContasAreceberOpen, setIsContasAreceberOpen] = useState(false);


  const [formData, setFormData] = useState({
    codvenda: '',
    dtvenda: '',
    tipo: '',
    nomecli: '',
    codcli: '',
    cnpjcli: '',
    empresa: '',
    codemp: '',
    cnpjemp: '',
    idcliente: '',  // Estado para armazenar dados do cliente selecionado
    pesoliqd: '',
    pesobruto: '',
    unidade: '',
    entregues: 0,
    devolvidos: 0,
    saldo: 0
  });


  useEffect(() => {
    // Atualiza os detalhes da venda quando o componente é montado
    if (venda) {
      setFormData({
        ...venda,
        idcliente: venda.cliente ? venda.cliente.id : '',
        nomecli: venda.cliente ? venda.cliente.nomecli : '',
        codcli: venda.cliente ? venda.cliente.codcli : '',
        cnpjcli: venda.cliente ? venda.cliente.cnpjcli : '',
        valvenda: venda.valvenda, // Atualizando valvenda no estado
      });
      setCodVendaParaEditar(venda.codvenda); // Definir o código da venda para atualizar
    }
  }, [venda]);

  useEffect(() => {
    // Atualiza os detalhes da venda ao definir o código da venda
    if (codVendaParaEditar) {
      fetchVendaPorCodvenda(codVendaParaEditar);
    }
  }, [codVendaParaEditar]);


  useEffect(() => {
    const saldo = formData.entregues - formData.devolvidos;
    setFormData(prevData => ({
      ...prevData,
      saldo,
    }));
  }, [formData.entregues, formData.devolvidos]);


  const fetchItensVenda = (codvenda) => {
    api.get(`/areceber/${codvenda}/itens`)
      .then(response => setItensVenda(response.data))
      .catch(error => console.error('Erro ao buscar itens da venda:', error));
  };

  const fetchVendaPorCodvenda = async (codvenda) => {
    try {
      const response = await api.get(`/buscarvenda?codvenda=${codvenda}`)
      
      if (response.data) {
        setDetalhesVenda(response.data);
        setFormData(response.data);
      }
    } catch (error) {
      console.error('Erro ao buscar venda por Código da Venda:', error);
    }
  };

  const handleSaveItens = () => {
    api.get(`/areceber/${detalhesVenda.codvenda}/itens`)
      .then(response => {
        setItensVenda(response.data);
        fetchVendaPorCodvenda(detalhesVenda.codvenda);
      })
      .catch(error => console.error('Erro ao atualizar itens da venda:', error));
  };


// Função para abrir ou fechar o modal de Editar Itens da Venda
  const toggleEditarItensVenda = (codvenda) => {
    if (!editarItensVenda && codvenda) {
      setCodVendaParaEditar(codvenda);
      fetchItensVenda(codvenda);
    }
    setEditarItensVenda(!editarItensVenda);
  };


  // Função para fechar o modal de Editar Itens da Venda e dar refresh
  const handleFecharModalEditarItensVenda = () => {
    console.log('Modal de Edição Itens da Venda Fechado'); // Adicionando log
    setEditarItensVenda(false);
    fetchVendaPorCodvenda(codVendaParaEditar); // Atualiza os detalhes da venda após editar os itens
  };

// Função para abrir ou fechar o modal de Contas a Receber
    const toggleContasAreceber = () => {
    setIsContasAreceberOpen(!isContasAreceberOpen);
  };

  const handleSaveContasAreceber = () => {
    // Lógica adicional após salvar contas a receber, se necessário
    console.log('Contas a Receber salvas com sucesso.');
    toggleContasAreceber();
  };


  const paymentMethods = ['', 'Em Espécie', 'PIX', 'Cartão', 'Boleto', 'Depósito', 'Transferência'];
  const conditionMethods = ['', 'À Vista', '15 DD', '30 DD', '60 DD', '30-60 DD', '30-60-90 DD'];

  const handleChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };


  // Função para obter a data atual no formato yyyy-mm-dd
  const getDataAtualISO = () => {
    const data = new Date();
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0'); // Janeiro é 0!
    const ano = data.getFullYear();
    return `${ano}-${mes}-${dia}`;
  };


  const handleSalvaEditada = async () => {
    if (isSaving) {
      return;
    }

    const mandatoryFields = ['nomecli', 'cnpjcli'];
    const hasErrors = mandatoryFields.some(field => {
      const value = formData[field];
      console.log(`Campo ${field}:`, value);
      return typeof value !== 'string' || value.trim() === '';
   });

    if (hasErrors) {
      alert('A Seleção do Cliente é Obrigatória.');
      return;
    }
    // Se a data da Venda estiver vazia, define a data atual
    if (!formData.dtvenda.trim()) {
      formData.dtvenda = getDataAtualISO();
    }
    setIsSaving(true);
    try {
      console.log('Enviando dados da Venda:', formData);
      const response = await api.put(`/vendas/alterarvenda/${venda.codvenda}`, formData, {
        headers: { 'Content-Type': 'application/json'},
      });


      console.log('Venda editada com sucesso:', response.data);
      handleEditClick(response.data); // Atualiza a lista de Vendas e redireciona

      } catch (error) {
      console.error('Erro ao editar Venda:', error.response ? error.response.data : error.message);
    } finally {
      setIsSaving(false);
    }
  };


  const handleClienteSelecionado = (cliente) => {
    setFormData({
      ...formData,
      codcli: cliente.codcli,
      nomecli: cliente.nomecli,
      cnpjcli: cliente.cnpjcli,
    });
    setPesquisarCliente(false);
  };

  // Função para abrir ou fechar os detalhes do cliente
  const toggleDetalhesCliente = () => {
    setDetalhesCliente(!detalhesCliente);
  };


  // eslint-disable-next-line no-unused-vars
  const handleOpenModalPesquisaCliente = () => setPesquisarCliente(true);
  const handleCloseModalPesquisaCliente = () => setPesquisarCliente(false);


  const [showModalBoleto, setShowModalBoleto] = useState(false);

  const handleOpenModalBoleto = () => setShowModalBoleto(true);
  const handleCloseModalBoleto = () => setShowModalBoleto(false);


  return (

    <div
      style={{
        minHeight: 'calc(100vh - 20px)',
        maxWidth: '900px',
        paddingTop: '10px',
        marginLeft: '0px',
        margin: '0 auto', // Centralizando o container
        textAlign: 'center', // Alinhamento central
      }}
    >

      <div style={{ marginBottom: '20px'}}>
        <h3>Edição de Contas a Receber</h3>
      </div>

      {/* Campos de Edição da Venda */}

        <div style={{ textAlign: 'left', marginLeft: '20px' }}>

          <div style={{ display: 'flex', marginBottom: '0px', marginTop: '0px'  }}>

            <div style={{ width: '100px', marginRight: '20px' }}>
              <label style={{ display: 'block', width: '100px', marginRight: '20px' }}>Venda</label>
              <CodigoField value={formData.codvenda} onChange={value => handleChange('codvenda', value)} />
            </div>
          

            <div style={{ width: '120px', marginBottom: '0px' }}>
              <label style={{ display: 'block', width: '120px', marginBottom: '0px' }}>Data da Venda</label>
            <DatepickerField  style={{ width: '120px', height: '28px', marginBottom: '0px' }} value={formData.dtvenda} onChange={value => handleChange('dtvenda', value)} />
            </div>
        

            <div style={{ width: '160px', marginBottom: '0px' , marginLeft: '20px' }}>
            <label style={{ display: 'block', width: '160px', marginBottom: '0px'  }}>Tipo da Venda</label>
            <TipoField value={formData.tipo} onChange={value => handleChange('tipo', value)} />
            </div>

            <div style={{ marginLeft: '20px', marginBottom: '0px'  }}>
              <button onClick={() => toggleEditarItensVenda(venda.codvenda)} style={{ width: '100px', marginBottom: '0px' , marginTop: '20px', height: '30px' }}>Editar Itens</button>
            </div>

            <div style={{ marginLeft: '20px' }}>
              <button onClick={() => setPesquisarCliente(true)} style={{ width: '140px', marginTop: '20px', height: '30px' }}>Seleção Cliente</button>
            </div>

            <div style={{ marginLeft: '20px', marginBottom: '0px'  }}>
              <button onClick={toggleDetalhesCliente} style={{ width: '110px', marginTop: '20px', marginBottom: '0px' , height: '30px' }}>Ficha Cliente</button>
            </div>

          </div>

          <div style={{ display: 'flex', marginTop: '0px' }}>

            <div style={{ marginRight: '20px', marginTop: '0px', width: '420px' }}>
              <label style={{ display: 'block', width: '420px', marginTop: '0px', marginRight: '20px' }}>Cliente</label>
              <input type="text" value={formData.nomecli} onChange={e => handleChange('nomecli', e.target.value)} readOnly style={{ width: '420px', marginTop: '0px', marginRight: '20px', height: '30px' }} />
            </div>
          
            <div style={{ width: '100px', marginTop: '0px' }}>
              <label style={{ display: 'block', width: '100px', marginTop: '0px' }}>Cód Cliente</label>
              <input type="text" value={formData.codcli} onChange={e => handleChange('codcli', e.target.value)} readOnly style={{ width: '100px', height: '30px' }} />
            </div>
          
            <div style={{ width: '150px', marginTop: '0px' }}>
              <label style={{ display: 'block', width: '150px', marginTop: '0px', marginLeft: '20px' }}>CNPJ do Cliente</label>
              <input type="text" value={formData.cnpjcli} onChange={e => handleChange('cnpjcli', e.target.value)} readOnly style={{ width: '150px', marginLeft: '20px', marginTop: '0px', height: '30px' }} />
            </div>
          
            <div style={{ marginLeft: '20px', marginBottom: '0px' }}>
              <button
              onClick={() => window.open('https://amei.sebrae.com.br/auth/realms/externo/protocol/openid-connect/auth?client_id=emissor-nfe-frontend&redirect_uri=https%3A%2F%2Femissornfe.sebrae.com.br%2F&state=3e67ca49-22c2-4e8f-8e58-335c65748c49&response_mode=fragment&response_type=code&scope=openid&nonce=4fa8e9a6-0700-4a53-bf92-27ff79eaff34', '_blank', 'noopener,noreferrer')}
              style={{ width: '100px', marginTop: '24px', marginBottom: '0px', marginLeft: '20px', height: '30px' }}
              >Nota Fiscal</button>
            </div>
                     
          </div>
        

        <div style={{ display: 'flex', marginBottom: '0px' }}>
          
          <div style={{ marginRight: '20px', width: '420px' }}>
            <label style={{ display: 'block', width: '420px' }}>Empresa</label>
            <input type="text" value={venda.empresa} readOnly style={{ width: '420px', height: '30px' }} />
          </div>

          <div style={{ width: '100px', marginTop: '0px' }}>
            <label style={{ display: 'block', width: '100px', marginTop: '0px' }}>Cód Empresa</label>
            <input type="text" value={formData.codemp} onChange={e => handleChange('codemp', e.target.value)} readOnly style={{ width: '100px', height: '30px' }} />
          </div>  
          
          <div style={{ width: '150px', marginTop: '0px' }}>
            <label style={{ display: 'block', width: '150px', marginTop: '0px', marginLeft: '20px' }}>CNPJ da Empresa</label>
            <input type="text" value={formData.cnpjemp} onChange={e => handleChange('cnpjemp', e.target.value)} readOnly style={{ width: '150px', marginLeft: '20px', marginTop: '0px', height: '30px' }} />
          </div>
          
          <div style={{ marginLeft: '20px', marginBottom: '0px' }}>
            <button className="open-modal-button" onClick={handleOpenModalBoleto}
            style={{ width: '100px', marginTop: '24px', marginBottom: '0px', marginLeft: '20px', height: '30px' }}
            >Boletos</button>
          </div>

        </div>

        
        <div style={{ display: 'flex', marginBottom: '0px' }}>

          <div style={{ width: '100px', marginRight: '0px' }}>
          <label style={{ display: 'block', width: '100px', marginBottom: '0px', marginRight: '20px' }}>Nota Fiscal</label>
          <input type="text" value={formData.nfvenda} onChange={e => handleChange('nfvenda', e.target.value)}
          style={{ width: '100px', height: '28px' }} />
          </div>

          
          <div style={{ width: '100px', marginLeft: '20px', marginRight: '0px', marginBottom: '0px' }}>
          <label style={{ display: 'block', width: '100px' }}>Valor Venda</label>
          <CurrencyField value={formData.valvenda} onChange={value => handleChange('valvenda', value)} />
          </div>
          
          <div style={{ width: '200px', marginLeft: '20px', marginBottom: '0px' }}>
          <FormaPagamentoSelect 
          paymentMethods={paymentMethods} 
          selectedMethod={formData.formapag} 
          onChange={(value) => handleChange('formapag', value)} />
          </div>
          
          <div style={{ width: '230px', marginLeft: '20px', marginBottom: '0px' }}>
          <CondPagamentoSelect 
          conditionMethods={conditionMethods} 
          selectedMethod={formData.condpag} 
          onChange={(value) => handleChange('condpag', value)} />
          </div>
          
          <div style={{ marginLeft: '20px', marginBottom: '0px', marginTop: '5px'  }}>
          <button onClick={toggleContasAreceber}
          style={{ width: '100px', marginLeft: '20px', marginBottom: '0px', marginTop: '20px', height: '30px' }}>
          A Receber</button>
          </div>

        </div>          

        <div style={{ display: 'flex', marginBottom: '0px' }}>


          <div style={{ width: '120px', marginLeft: '0px' }}>
            <label style={{ display: 'block', width: '120px', marginBottom: '0px' }}>Data Nota Fiscal</label>
            <DatepickerField value={formData.dtnfvenda} onChange={value => handleChange('dtnfvenda', value)}
            style={{ width: '120px', height: '28px' }}/>
          </div>
          <div style={{ width: '80px', marginLeft: '20px' }}>
            <label style={{ display: 'block', width: '80px', marginLeft: '0px' }}>Peso Lqd.</label>
            <input type="text" value={formData.pesoliqd} onChange={e => handleChange('pesoliqd', e.target.value)}
              style={{ width: '80px', height: '30px' }} />
          </div>
          <div style={{ width: '80px', marginLeft: '20px' }}>
            <label style={{ display: 'block', width: '80px', marginLeft: '0px'  }}>Peso Brt.</label>
            <input type="text" value={formData.pesobruto} onChange={e => handleChange('pesobruto', e.target.value)}
              style={{ width: '80px', height: '30px' }} />
          </div>
          <div style={{ width: '70px', marginLeft: '20px' }}>
            <label style={{ display: 'block', width: '70x', marginLeft: '0px' }}>Unidade</label>
            <input type="text" value={formData.unidade} onChange={e => handleChange('unidade', e.target.value)}
            style={{ width: '70px', height: '30px' }} />
          </div>
          <div style={{ width: '70px', marginLeft: '20px' }}>
            <label style={{ display: 'block', width: '70px', marginLeft: '0px' }}>Entregue</label>
            <input type="text"value={formData.entregues} onChange={e => handleChange('entregues', parseFloat(e.target.value) || 0)}
            style={{ width: '70px', height: '30px' }} />
          </div>         
          <div style={{ width: '70px', marginLeft: '20px' }}>
            <label style={{ display: 'block', width: '70px', marginLeft: '0px' }}>Devolvido</label>
            <input type="text" value={formData.devolvidos} onChange={e => handleChange('devolvidos', parseFloat(e.target.value) || 0)}
            style={{ width: '70px', height: '30px' }} />
          </div>
          <div style={{ width: '60px', marginLeft: '20px' }}>
            <label style={{ display: 'block', width: '60px', marginLeft: '0px' }}>Saldo</label>
            <input type="text" value={formData.saldo} readOnly
            style={{ width: '60px', height: '30px' }} />
          </div>
        
        </div>
                                            
      <div style={{ display: 'flex', marginBottom: '0px' }}>
        <div style={{ width: '100px', marginRight: '20px' }}>
          <label style={{ display: 'block', width: '100px' }}>Grupo</label>
          <input type="text" value={venda.grupo} readOnly style={{ width: '100px', height: '30px' }} />
        </div>
        <div style={{ width: '180px', marginRight: '20px' }}>
          <label style={{ display: 'block', width: '180px', marginRight: '20px' }}>Descrição</label>
          <input type="text" value={venda.grupodesc} readOnly style={{ width: '180px', height: '30px' }} />
        </div>
        <div style={{ width: '100px', marginRight: '20px' }}>
          <label style={{ display: 'block', width: '100px', marginRight: '20px'  }}>conta</label>
          <input type="text" value={venda.conta} readOnly style={{ width: '100px', height: '30px' }} />
        </div>
        <div style={{ width: '240px', marginRight: '20px' }}>
          <label style={{ display: 'block', width: '240px', marginRight: '20px' }}>Descrição</label>
          <input type="text" value={venda.contadesc} readOnly style={{ width: '240px', height: '30px' }} />
        </div>   
      </div>          


      <div style={{ display: 'flex', marginBottom: '0px' }}>
        <div style={{ width: '110px', marginRight: '20px' }}>
          <label style={{ display: 'block', width: '110px' }}>Romaneio</label>
          <input type="text" value={venda.romaneio} readOnly style={{ width: '110px', height: '30px' }} />
        </div>
        <div style={{ width: '110px', marginRight: '20px' }}>
          <label style={{ display: 'block', width: '110px', marginRight: '20px' }}>Veículo</label>
          <input type="text" value={venda.placa} readOnly style={{ width: '110px', height: '30px' }} />
        </div>
        <div style={{ width: '160px', marginRight: '20px' }}>
          <label style={{ display: 'block', width: '160px', marginRight: '20px'  }}>Motorista</label>
          <input type="text" value={venda.motorista} readOnly style={{ width: '160px', height: '30px' }} />
        </div>
        <div style={{ width: '160px', marginRight: '20px' }}>
          <label style={{ display: 'block', width: '160px', marginRight: '20px' }}>Ajudante</label>
          <input type="text" value={venda.ajudante} readOnly style={{ width: '160px', height: '30px' }} />
        </div>   
      </div>     
                                      
       {/* Modal Detalhes do Cliente */}
      {detalhesCliente && venda?.cliente && (
          <ModalDetahesCliente
            cliente={venda.cliente}
            fecharDetalhes={toggleDetalhesCliente}
          />
        )}
        

       {/* Modal Pesquisar Cliente */}
      {pesquisarCliente && (
        <ModalPesquisarCliente
        isOpen={pesquisarCliente}
        onClose={handleCloseModalPesquisaCliente}
        onClienteSelecionado={handleClienteSelecionado}
        />
      )}

      {/* Modal Editar Itens da Venda*/}         
      {editarItensVenda && (
        <ModalEditarItensVenda
          isOpen={editarItensVenda}
          fecharModal={handleFecharModalEditarItensVenda}
          codVenda={codVendaParaEditar}
          onSave={handleSaveItens}
         />
      )}

      {/* Modal ModalContasAreceber */}
      {isContasAreceberOpen && (
        <ModalContasAreceber
        isOpen={isContasAreceberOpen}
        dadosVenda={venda} 
        codVenda={venda.codvenda} 
        valVenda={venda.valvenda}  // Use a variável com o valor atualizado
        fecharModal={toggleContasAreceber}
        onSave={handleSaveContasAreceber}
        />
      )}

      <ModalBoletoControl
          isOpen={showModalBoleto}
          codVenda={venda.codvenda} 
        onClose={handleCloseModalBoleto}
      />   


    <br/>

      <Box display="flex" justifyContent="center" alignItems="center" mt={0}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0px' }}>
          <button  type="button" className='btn-menu' onClick={handleSalvaEditada} style={{ width: '100px', height: '30px', padding: '3px 5px', marginRight: '50px', color: 'inherit' }}>
          {isSaving ? 'Salvando...' : 'Salvar'}
          </button>
          <button  type="button" className='btn-menu' onClick={handleCancelaEdit} style={{ width: '100px', height: '30px', padding: '3px 5px', color: 'inherit' }}>
            Cancelar
          </button>
          </div>
        </Box>
          
        </div>

    </div>

  );
};

export default EditarApagar;